"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HAS_WINDOW_LISTENERS = void 0;

var _featureDetection = require("@eb/feature-detection");

/**
 * Safely checks if the window exists and supports eventListeners
 */
var HAS_WINDOW_LISTENERS = !!(0, _featureDetection.getWindowObject)('addEventListener');
exports.HAS_WINDOW_LISTENERS = HAS_WINDOW_LISTENERS;
//# sourceMappingURL=has-window-listeners.js.map